import gql from "graphql-tag";

const getEmployeeConfig = gql`
  query {
    getEmployeeConfig {
      id
      hrDepartment {
        id
        name
      }
      workOvertimeApprovers {
        id
        fullname
        username
        email
      }
      workLeaveApprovers {
        id
        fullname
        username
        email
      }
      travelRequestApprovers {
        id
        fullname
        username
        email
      }
    }
  }
`;

const users = gql`
  query($query: String) {
    users(query: $query) {
      id
      fullname
      username
      email
    }
  }
`;

const updateEmployeeConfig = gql`
  mutation(
    $hrDepartmentId: ID
    $workLeaveApproverIds: [ID!]
    $workOvertimeApproverIds: [ID!]
    $travelRequestApproverIds: [ID!]
  ) {
    updateEmployeeConfig(
      data: {
        hrDepartmentId: $hrDepartmentId
        workOvertimeApproverIds: $workOvertimeApproverIds
        workLeaveApproverIds: $workLeaveApproverIds
        travelRequestApproverIds: $travelRequestApproverIds
      }
    ) {
      id
      hrDepartment {
        id
        name
      }
      workOvertimeApprovers {
        id
        fullname
        username
        email
      }
      workLeaveApprovers {
        id
        fullname
        username
        email
      }
    }
  }
`;

export default { getEmployeeConfig, users, updateEmployeeConfig };
